import { useContext, useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { NCA_JOURNEY_TIME_OF_CHECK_UPDATES } from '@constants';
import AppContext from '@context';
import { checkUpdatesDebounced } from '@services/journeys';

const useCheckUpdates = () => {
  const {
    state: {
      journeys: {
        all: {
          isFetched,
          isFetching,
          meta: { lastUpdate },
        },
      },
    },
  } = useContext(AppContext);
  const [hasUpdateAvailable, setHasUpdateAvailable] = useState(false);

  useQuery(
    'checkUpdatesToReloadList',
    async () => {
      if (isFetched && lastUpdate) {
        const response = await checkUpdatesDebounced(lastUpdate);
        if (response?.hasNewJourneys) {
          setHasUpdateAvailable(true);
        }
      }
    },
    {
      refetchInterval: !hasUpdateAvailable
        ? parseInt(NCA_JOURNEY_TIME_OF_CHECK_UPDATES, 10)
        : false,
      refetchIntervalInBackground: false,
      refetchOnWindowFocus: !hasUpdateAvailable,
      retry: false,
    },
  );

  useEffect(() => {
    if (isFetching) {
      setHasUpdateAvailable(false);
    }
  }, [isFetching]);

  return { hasUpdateAvailable };
};

export default useCheckUpdates;
